
const colors = {
    primary:  '#557',
    blue:     '#5A8EC8',
    dark:     '#424D7D',
    blue_:    '#66C',
    darkblue: '#55B'
}

export default colors
